<template>
  <div style="overflow: hidden;">
    <div class="bg"></div>
    <div class="content">
      <div class="info">
        <div class="photo" :style="'background-image: url(' + doctorData.frontImg || doctorImg + ');'"></div>
        <div class="detail">
          <div class="name-title">
            <span class="name">{{doctorData.doctorName}}</span>
            <span class="title">{{doctorData.titleName}}</span>
          </div>
          <div class="company">
            <p class="department">{{doctorData.department}}</p>
            <p class="line"></p>
            <p class="hospital">{{doctorData.hospitalName}}</p>
          </div>
        </div>
      </div>
      <div class="block">
        <h3>擅长</h3>
        <div>{{doctorData.professional}}</div>
      </div>
      <div class="block">
        <h3>简介</h3>
        <div>{{doctorData.dec}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import doctorImg from '@/assets/doctor_default.png';
import { consultDoctorDetail } from '@/api/doctor';

export default {
  data() {
    return {
      doctorImg,
      id: '',
      doctorData: {},
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.hospitalType = this.$route.query.hospitalType || '';
    this.getDoctorDetail();
  },
  methods: {
    // 获取医生详情
    getDoctorDetail() {
      // this.$toast.loading({
      //   duration: 0,
      //   forbidClick: true,
      //   message: '加载中...',
      // });

      // getDoctorDetailInfo({
      //   id: this.id,
      //   hospitalType: this.hospitalType,
      // }).then((res) => {
      //   if (res.code === 200) {
      //     this.doctorData = res.data;
      //     this.$toast.clear();
      //   }
      // });
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
      consultDoctorDetail({
        doctorId: this.id,
      }).then((res) => {
        if (res.code === 200) {
          this.doctorData = res.data;
          this.$toast.clear();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  height: 250px;
  padding: 20px;
  background: linear-gradient(180deg, #f3fff9 0%, #f6f7f9 100%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1;
}

.content {
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}

.info {
  padding: 20px;

  @include flex(center);

  .photo {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-radius: 50%;
    margin-right: 12px;
  }

  .detail {
    width: calc(100% - 72px);

    @include font(13px, 18px, $primary-text-color);
  }

  .name-title {
    margin-bottom: 8px;

    @include flex(center);
  }

  .name {
    font-weight: $font-bold;

    @include font(18px, 25px);
  }

  .title {
    margin: 0 8px;
  }

  .company {
    color: $secondary-text-color;

    @include flex();

    .department {
      flex-shrink: 0;
      max-width: 80px;

      @include line-ellipsis;
    }

    .line {
      flex-shrink: 0;
      width: 1px;
      height: 11px;
      background-color: #bbb;
      margin: 0 10px;
    }

    .hospital {
      width: 100%;

      @include line-ellipsis;
    }
  }
}

.block {
  margin: 0 15px 12px;
  padding: 15px;
  background-color: #fff;
  border-radius: $regular-border-radius;

  @include font(15px, 23px, $secondary-text-color);

  h3 {
    padding-bottom: 10px;
    font-weight: $font-bold;

    @include font(16px, 22px, $primary-text-color);
  }
}
</style>